import { useQuery } from '@tanstack/react-query';

import { clientsClient } from 'services/connectivity/clients/client';
import { ClientResponse } from 'services/connectivity/clients/types';
import { getAccessToken } from 'helpers/account';
import { errorDeserialize } from 'helpers/error-deserializer';

interface UseGetClient {
  client: ClientResponse;
  isLoading: boolean;
}

export const fetchClient = async (clientId: string, token: string): Promise<ClientResponse> => {
  const { error, result } = await clientsClient.get(clientId, token);

  if (error) {
    throw errorDeserialize(error);
  }

  return result;
};

export const useGetClient = (clientId: string): UseGetClient => {
  const { data: client, isLoading } = useQuery({
    queryKey: ['get-client', clientId],
    queryFn: () => fetchClient(clientId, getAccessToken()),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2,
    enabled: !!clientId,
  });

  return {
    client,
    isLoading,
  };
};
